import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";

const OtpScreen = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  

  const handleSubmit = async () => {
    if (!otp || otp.length !== 6 || isNaN(otp)) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }

    try {
      setError('');
      const token = localStorage.getItem('authToken');

      const response = await fetch(`${BASE_URL}/verify_otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id, otp }),
      });

      const result = await response.json();

      if (result.status) {
        setSuccessMsg('OTP verified successfully!');
        navigate('/manage_employee');
      } else {
        setError(result.message || 'Invalid OTP');
      }
    } catch (err) {
      console.error('API Error:', err);
      setError('Something went wrong while verifying OTP');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="card p-4" style={{ width: '350px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
        <h4 className="text-center mb-3">OTP/Reference number</h4>
        
        {/* ✅ Show Name and Mobile */}
        <div className="text-center mb-3">
          
        </div>

        <input
          type="text"
          className="form-control mb-3 text-center"
          maxLength="6"
          placeholder="6-digit OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />

        {error && <p className="text-danger small">{error}</p>}
        {successMsg && <p className="text-success small">{successMsg}</p>}

        <button className="btn btn-primary w-100" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default OtpScreen;
